// PR6's "Waiting to upload (n)" list (DS mobile recorder, artboard 3b) needs a durable,
// multi-recording queue to be worth the name — one that survives a tab close or an app
// restart. That is F5's job (the pending-upload list PR, #72), not merged into staging yet.
//
// TODO(F5): once the pending-upload list lands, replace this with whatever it exposes
// (recoverable sessions on disk, grouped by grackle) instead of this single in-memory entry.
// Until then this is a typed, honest stand-in: the one upload this tab actually knows about,
// derived straight from UploadQueueSnapshot, so the mobile recorder has something real to show
// rather than either nothing or sample data.
import type { UploadQueuePhase, UploadQueueSnapshot } from "./uploadQueue";

export interface PendingUpload {
  id: string;
  title: string;
  bytesRecorded: number;
  bytesAccepted: number;
  phase: UploadQueuePhase;
  lastError: string | null;
}

/** Empty once there is nothing left to show the user: no upload started yet, or it already
 * finished/was discarded. */
export function pendingUploadsFrom(snapshot: UploadQueueSnapshot | null, title: string): PendingUpload[] {
  if (!snapshot) return [];
  if (snapshot.phase === "idle" || snapshot.phase === "done" || snapshot.phase === "canceled") return [];
  return [
    {
      id: snapshot.grackleId ?? "pending",
      title,
      bytesRecorded: snapshot.bytesRecorded,
      bytesAccepted: snapshot.bytesAccepted,
      phase: snapshot.phase,
      lastError: snapshot.lastError,
    },
  ];
}
